/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import { 
    ProjectCredentials, 
    ProjectCredentialsInput,
    ProjectCredentialsInputToJSON,
    UpdateProjectCredentialsDto,
    UpdateProjectCredentialsDtoToJSON
} from '../models';

/**
 * 
 * @export
 * @interface ProjectCredentialsApiResult
 */
export interface ProjectCredentialsApiResult {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectCredentialsApiResult
     */
    success?: boolean;
    /**
     * 
     * @type {ProjectCredentials}
     * @memberof ProjectCredentialsApiResult
     */
    content?: ProjectCredentials | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentialsApiResult
     */
    message?: string | null;
}

/**
 * 
 * @export
 * @interface ProjectCredentialsListApiResult
 */
export interface ProjectCredentialsListApiResult {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectCredentialsListApiResult
     */
    success?: boolean;
    /**
     * 
     * @type {Array<ProjectCredentials>}
     * @memberof ProjectCredentialsListApiResult
     */
    content?: Array<ProjectCredentials> | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectCredentialsListApiResult
     */
    message?: string | null;
}

/**
 * ProjectAccountApi - interface
 *
 * @export
 * @interface ProjectAccountApiInterface
 */
export interface ProjectAccountApiInterface {
    /**
     * 
     * @param {string} id
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAccountApiInterface
     */
    projectAccountGet(id: string, name: string, initOverrides?: RequestInit): Promise<ProjectCredentialsApiResult>;

    /**
     * 
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAccountApiInterface
     */
    projectAccountGetByProjectId(projectId: string, initOverrides?: RequestInit): Promise<ProjectCredentialsListApiResult>;

    /**
     * 
     * @param {ProjectCredentialsInput} [projectCredentialsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAccountApiInterface
     */
    projectAccountSet(projectCredentialsInput?: ProjectCredentialsInput, initOverrides?: RequestInit): Promise<ProjectCredentialsApiResult>;

    /**
     * 
     * @param {UpdateProjectCredentialsDto} [updateProjectCredentialsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectAccountApiInterface
     */
    projectAccountUpdate(updateProjectCredentialsDto?: UpdateProjectCredentialsDto, initOverrides?: RequestInit): Promise<ProjectCredentialsApiResult>;
}

/**
 * 
 */
export class ProjectAccountApi extends runtime.BaseAPI implements ProjectAccountApiInterface {

    /**
     */
    async projectAccountGet(id: string, name: string, initOverrides?: RequestInit): Promise<ProjectCredentialsApiResult> {
        const response = await this.projectAccountGetRaw({ id: id, name: name }, initOverrides);
        return await response.value();
    }

    /**
     */
    async projectAccountGetRaw(requestParameters: { id: string, name: string }, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProjectCredentialsApiResult>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling projectAccountGet.');
        }

        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling projectAccountGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        const response = await this.request({
            path: `/ProjectAccount/Get/{id}/{name}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
    }

    /**
     */
    async projectAccountGetByProjectId(projectId: string, initOverrides?: RequestInit): Promise<ProjectCredentialsListApiResult> {
        const response = await this.projectAccountGetByProjectIdRaw({ projectId: projectId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async projectAccountGetByProjectIdRaw(requestParameters: { projectId: string }, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProjectCredentialsListApiResult>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling projectAccountGetByProjectId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        const response = await this.request({
            path: `/ProjectAccount/GetByProjectId/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
    }

    /**
     */
    async projectAccountSet(projectCredentialsInput?: ProjectCredentialsInput, initOverrides?: RequestInit): Promise<ProjectCredentialsApiResult> {
        const response = await this.projectAccountSetRaw({ projectCredentialsInput: projectCredentialsInput }, initOverrides);
        return await response.value();
    }

    /**
     */
    async projectAccountSetRaw(requestParameters: { projectCredentialsInput?: ProjectCredentialsInput }, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProjectCredentialsApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        const response = await this.request({
            path: `/ProjectAccount/Set`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectCredentialsInputToJSON(requestParameters.projectCredentialsInput),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
    }

    /**
     */
    async projectAccountUpdate(updateProjectCredentialsDto?: UpdateProjectCredentialsDto, initOverrides?: RequestInit): Promise<ProjectCredentialsApiResult> {
        const response = await this.projectAccountUpdateRaw({ updateProjectCredentialsDto: updateProjectCredentialsDto }, initOverrides);
        return await response.value();
    }

    /**
     */
    async projectAccountUpdateRaw(requestParameters: { updateProjectCredentialsDto?: UpdateProjectCredentialsDto }, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProjectCredentialsApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        const response = await this.request({
            path: `/ProjectAccount/Update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProjectCredentialsDtoToJSON(requestParameters.updateProjectCredentialsDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
    }
} 